export default "/assets/images/pair-your-mila.6caeb213a9eaa1cd.png";